export default __webpack_public_path__ + "static/media/21.08920ea7.svg";